import { useFlags } from 'config/useFlagsContext'

import { NewsInternalEstabilizacaoV50 } from '../internal-panels/NewsInternalEstabilizacaoV_50'
import { NewsInternalEstabilizacaoV51 } from '../internal-panels/NewsInternalEstabilizacaoV_51'
import { NewsInternalEstabilizacaoV52 } from '../internal-panels/NewsInternalEstabilizacaoV_52'
import { NewsInternalEstabilizacaoV53 } from '../internal-panels/NewsInternalEstabilizacaoV_53'
import { NewsInternalEstabilizacaoV54 } from '../internal-panels/NewsInternalEstabilizacaoV_54'
import { NewsInternalEstabilizacaoV55 } from '../internal-panels/NewsInternalEstabilizacaoV_55'
import { NewsInternalPanelCincoZero } from '../internal-panels/NewsInternalPanelV5_00'
import { NewsInternalPanelCincoUm } from '../internal-panels/NewsInternalPanelV5_10'
import { NewsInternalPanelCincoDois } from '../internal-panels/NewsInternalPanelV5_20'
import { NewsInternalPanelCincoTres } from '../internal-panels/NewsInternalPanelV5_30'
import { NewsInternalPanelCincoQuatro } from '../internal-panels/NewsInternalPanelV5_40'
import { NewsInternalPanelCincoCinco } from '../internal-panels/NewsInternalPanelV5_50'

export type NewsVersion =
  | '5-5-estabilizacao'
  | '5-5'
  | '5-4-estabilizacao'
  | '5-4'
  | '5-3-estabilizacao'
  | '5-3'
  | '5-2-estabilizacao'
  | '5-2'
  | '5-1-estabilizacao'
  | '5-1'
  | '5-0-estabilizacao'
  | '5-0'

export type NewsTopics = ReadonlyArray<{ title: string; id: string }>

export type NewsItem = {
  title: string
  internalTitle?: string
  Panel: React.FC
  isEstabilizacao: boolean
  topics: NewsTopics
}

function getTopicIfEnabled(topic: { title: string; id: string }, flag: boolean) {
  if (!flag) return []
  return [topic]
}

export default function useNewsItems() {
  const {
    CADASTRO_IMOVEL_ENABLED,
    SAUDE_INDIGENA_ENABLED,
    PILOTO_VINCULACAO_CUIDADO_ENABLED,
    PILOTO_SDC_PRE_ECLAMPSIA_ENABLED,
    PILOTO_INTEGRACAO_REGULACAO_ENABLED,
    PILOTO_DIABETES_HIPERTENSAO_LPC_ENABLED,
    PILOTO_PRESCRICAO_CONTROLADA_ENABLED,
    PROGRAMA_DIGNIDADE_MENSTRUAL_ENABLED,
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED,
    PILOTO_PRONTUARIO_FAMILIAR_ENABLED,
    PILOTO_RNDS_REPM_ENABLED,
    PILOTO_SDC_RISCO_CARDIOVASCULAR_ENABLED,
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED,
    PILOTO_ASSINADOR_REPM_ENABLED,
    PILOTO_SDC_RISCO_CARDIOVASCULAR_SEGUNDA_ENTREGA_ENABLED,
    PILOTO_EXAMES_SAUDE_MULHER_ENABLED,
    PILOTO_M_CHAT_RF_ENABLED,
    PAC_EQUIPAMENTO_ENABLED,
    PILOTO_GRAFICOS_PRE_TERMO_ENABLED,
    PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED,
    PILOTO_INATIVACAO_IMOVEIS_ENABLED,
    PILOTO_GRUPOS_ATIVIDADE_COLETIVA_ENABLED,
    PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED,
    MOTIVO_PRESCRICAO_ENABLED,
    SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED,
    PILOTO_CID11_ENABLED,
  } = useFlags()

  const NEWS_ITEMS: Record<NewsVersion, NewsItem> = {
    '5-5-estabilizacao': {
      title: 'Estabilização 5.5',
      internalTitle: 'Versões de estabilização 5.5',
      Panel: NewsInternalEstabilizacaoV55,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.5.21',
          id: 'estabilizacao-5-5-21',
        },
      ],
    },
    '5-5': {
      title: 'Versão 5.5',
      Panel: NewsInternalPanelCincoCinco,
      isEstabilizacao: false,
      topics: [
        ...getTopicIfEnabled(
          {
            title: 'Inclusão do campo de CID-11 na Avaliação do SOAP e na Lista de problemas/condições',
            id: 'cid11-problemas-condicoes-5-5',
          },
          PILOTO_CID11_ENABLED
        ),
        {
          title: 'Novos itens nos campos do registro de Atividade coletiva',
          id: 'novos-temas-public-alvo-ac-5-5',
        },
        {
          title: 'Atualização SIGTAP',
          id: 'sigtap-5-5',
        },
        {
          title: 'Novo modelo de atestado para Solicitação de fraldas geriátricas',
          id: 'solicitacao-fraldas-geriatricas-5-5',
        },
        {
          title: 'Inativação de procedimentos AB no sistema',
          id: 'inativacao-procedimentos-ab-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'RNDS - Registro Eletrônico de Prescrição de Medicamentos (REPM)',
            id: 'rnds-repm-5-5',
          },
          PILOTO_RNDS_REPM_ENABLED
        ),
        {
          title: 'Evolução do Módulo do Cidadão',
          id: 'novo-cidadao-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Aprimoramento do cálculo no SDC de Risco Cardiovascular',
            id: 'sdc-alerta-risco-cardiovascular-segunda-entrega-5-5',
          },
          PILOTO_SDC_RISCO_CARDIOVASCULAR_SEGUNDA_ENTREGA_ENABLED
        ),
        {
          title: 'Batimento cardíaco fetal para gestação dupla/gemelar',
          id: 'batimento-cardiaco-fetal2-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Classificação de Vulnerabilidade Familiar',
            id: 'vulnerabilidade-familiar-5-5',
          },
          PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED
        ),
        {
          title: 'Módulo de Acompanhamento de Pré-natal',
          id: 'acompanhamento-pre-natal-5-5',
        },
        {
          title: 'Módulo de Acompanhamento de Puerpério',
          id: 'acompanhamento-puerperio-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Retificação de atendimento de vacinação',
            id: 'retificacao-atendimento-vacinacao-5-5',
          },
          RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED
        ),
        {
          title: 'Sistemas externos',
          id: 'sistemas-externos-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Suporte à Decisão Clínica - Alerta de Risco Cardiovascular',
            id: 'sdc-alerta-risco-cardiovascular-5-5',
          },
          PILOTO_SDC_RISCO_CARDIOVASCULAR_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Suporte à Decisão Clínica - Alerta de Risco de Pré-Eclâmpsia',
            id: 'sdc-alerta-risco-pre-eclampsia-5-5',
          },
          PILOTO_SDC_PRE_ECLAMPSIA_ENABLED
        ),
        {
          title: 'Vinculação de cidadão e formação de famílias',
          id: 'vinculacao-cidadao-formacao-familias-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Avaliação do M-CHAT-R/F™ completo com Entrevista de Seguimento na puericultura',
            id: 'avaliacao-M-CHAT-RF-completo-entrevista-seguimento-puericultura-5-5',
          },
          PILOTO_M_CHAT_RF_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Regulação assistencial',
            id: 'regulacao-assistencial-5-5',
          },
          PILOTO_INTEGRACAO_REGULACAO_ENABLED
        ),
        {
          title: 'Renovar prescrição de uso contínuo',
          id: 'renovar-prescricao-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Adaptação dos gráficos de medições para crianças Pré-termo',
            id: 'graficos-pre-termo-5-5',
          },
          PILOTO_GRAFICOS_PRE_TERMO_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Criação e gestão de grupos de atividade coletiva',
            id: 'gestao-grupo-atividade-coletiva-5-5',
          },
          PILOTO_GRUPOS_ATIVIDADE_COLETIVA_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Inclusão do campo Motivo da prescrição',
            id: 'motivo-prescricao-5-5',
          },
          MOTIVO_PRESCRICAO_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Melhorias em Encaminhamento e Cuidado compartilhado',
            id: 'melhorias-encaminhamento-e-cc-5-5',
          },
          PILOTO_VINCULACAO_CUIDADO_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'PDFs para solicitar exames de mamografia e citopatológico de colo uterino',
            id: 'pdfs-solicitar-exames-saude-mulher-5-5',
          },
          PILOTO_EXAMES_SAUDE_MULHER_ENABLED
        ),
        {
          title: 'Possibilidade de escolha da idade gestacional',
          id: 'possibilidade-escolha-idade-gestacional-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Prontuário Familiar',
            id: 'prontuario-familiar-5-5',
          },
          PILOTO_PRONTUARIO_FAMILIAR_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Relatório gerencial de cadastro individual',
            id: 'relatorio-gerencial-cadastro-individual-5-5',
          },
          PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED
        ),
        {
          title: 'Painel de chamadas',
          id: 'painel-chamadas-5-5',
        },
        ...getTopicIfEnabled(
          {
            title: 'Retificação do atendimento de procedimentos',
            id: 'retificacao-procedimentos-5-5',
          },
          PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Assinatura digital REPM',
            id: 'assinatura-digital-repm-5-5',
          },
          PILOTO_ASSINADOR_REPM_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Inativação de imóveis',
            id: 'inativacao-imoveis-5-5',
          },
          PILOTO_INATIVACAO_IMOVEIS_ENABLED
        ),
        ...getTopicIfEnabled(
          {
            title: 'Nova solicitação para exame de citopatológico de colo uterino',
            id: 'solicitacao-exame-citopatologico-colo-uterino-5-5',
          },
          SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED
        ),
      ],
    },
    '5-4-estabilizacao': {
      title: 'Estabilização 5.4',
      internalTitle: 'Versões de estabilização 5.4',
      Panel: NewsInternalEstabilizacaoV54,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.4.38',
          id: 'estabilizacao-5-4-38',
        },
        {
          title: '5.4.37',
          id: 'estabilizacao-5-4-37',
        },
        {
          title: '5.4.36',
          id: 'estabilizacao-5-4-36',
        },
        {
          title: '5.4.35',
          id: 'estabilizacao-5-4-35',
        },
        {
          title: '5.4.34',
          id: 'estabilizacao-5-4-34',
        },
        {
          title: '5.4.33',
          id: 'estabilizacao-5-4-33',
        },
        {
          title: '5.4.32',
          id: 'estabilizacao-5-4-32',
        },
        {
          title: '5.4.31',
          id: 'estabilizacao-5-4-31',
        },
        {
          title: '5.4.30',
          id: 'estabilizacao-5-4-30',
        },
        {
          title: '5.4.29',
          id: 'estabilizacao-5-4-29',
        },
        {
          title: '5.4.28',
          id: 'estabilizacao-5-4-28',
        },
        {
          title: '5.4.27',
          id: 'estabilizacao-5-4-27',
        },
        {
          title: '5.4.26',
          id: 'estabilizacao-5-4-26',
        },
        {
          title: '5.4.25',
          id: 'estabilizacao-5-4-25',
        },
        {
          title: '5.4.24',
          id: 'estabilizacao-5-4-24',
        },
        {
          title: '5.4.23',
          id: 'estabilizacao-5-4-23',
        },
        {
          title: '5.4.22',
          id: 'estabilizacao-5-4-22',
        },
        {
          title: '5.4.21',
          id: 'estabilizacao-5-4-21',
        },
        {
          title: '5.4.19',
          id: 'estabilizacao-5-4-19',
        },
        {
          title: '5.4.18',
          id: 'estabilizacao-5-4-18',
        },
        {
          title: '5.4.17',
          id: 'estabilizacao-5-4-17',
        },
        {
          title: '5.4.15',
          id: 'estabilizacao-5-4-15',
        },
        {
          title: '5.4.14',
          id: 'estabilizacao-5-4-14',
        },
        {
          title: '5.4.13',
          id: 'estabilizacao-5-4-13',
        },
        {
          title: '5.4.11',
          id: 'estabilizacao-5-4-11',
        },
        {
          title: '5.4.10',
          id: 'estabilizacao-5-4-10',
        },
        {
          title: '5.4.9',
          id: 'estabilizacao-5-4-9',
        },
        {
          title: '5.4.8',
          id: 'estabilizacao-5-4-8',
        },
      ],
    },
    '5-4': {
      title: 'Versão 5.4',
      Panel: NewsInternalPanelCincoQuatro,
      isEstabilizacao: false,
      topics: [
        ...(PAC_EQUIPAMENTO_ENABLED
          ? [
              {
                title: 'Adição de Exame físico na Antropometria',
                id: 'adicao-do-exame-fisico-na-antropometria-5-4',
              },
            ]
          : []),
        {
          title: 'Cálculo e exibição de Idade corrigida no card de Acompanhamento da criança',
          id: 'calculo-idade-corrigida-card-acompanhamento-crianca-5-4',
        },
        {
          title: 'Melhorias na gestão de Grupos de Exames',
          id: 'melhoria-grupos-exames-5-4',
        },

        ...getTopicIfEnabled(
          {
            title: 'Inclusão de condições na lista de problemas/condições com base no histórico clínico',
            id: 'inclusao-condicoes-historico-lpc-5-4',
          },
          PILOTO_DIABETES_HIPERTENSAO_LPC_ENABLED
        ),

        { title: 'Anexo de arquivos no prontuário', id: 'anexo-arquivos-5-4' },
        { title: 'Atualização da Ficha de notificação de caso suspeito', id: 'notificacao-ficha-sinan-5-4' },
        { title: 'Avaliação do M-CHAT-R na puericultura', id: 'mchat-5-4' },

        {
          title: 'Novas funcionalidades para o Acompanhamento de condições de saúde',
          id: 'acompanhamento-condicoes-saude-5-4',
        },
        { title: 'Novas funcionalidades para o Cuidado compartilhado', id: 'novas-funcionalidades-cuidado-5-4' },

        {
          title: 'Novo relatório para monitoramento de envios para RNDS',
          id: 'relatorio-envio-sucesso-rnds-5-4',
        },
        {
          title: 'Novo relatório gerencial de exames',
          id: 'relatorio-gerencial-exames-5-4',
        },
        {
          title: 'Novos gráficos para crianças, adolescentes e gestantes',
          id: 'graficos-criancas-adolescentes-gestantes-5-4',
        },
        {
          title: 'Novo módulo e melhorias no registro de Atividades coletivas',
          id: 'atividade-coletiva-5-4',
        },
        {
          title: 'Indicação de óbito na Garantia de acesso',
          id: 'indicacao-obito-ga-5-4',
        },
        {
          title: 'Atualização dos resultados de exames quantitativos',
          id: 'atualizacao-resultados-exm-qualitativos-5-4',
        },
        {
          title: 'Atualização do atendimento de vacinação e do modelo RIA',
          id: 'atualizacao-atendimento-vacinacao-5-4',
        },
        {
          title: 'Atualização na exibição do IMC no atendimento de gestantes',
          id: 'atualizacao-imc-gestantes-5-4',
        },
        {
          title: 'Ajustes nos Gráficos de IMC e Peso durante a Gestação',
          id: 'ajustes-graficos-peso-imc-5-4',
        },

        {
          title: 'Sistema de Suporte à Decisão Clínica',
          id: 'suporte-decisao-clinica-5-4',
        },
        {
          title: 'Suporte à Decisão Clínica - Alerta de condutas recomendadas para dengue',
          id: 'suporte-decisao-clinica-conduta-dengue-5-4',
        },
        {
          title: 'Suporte à Decisão Clínica - Botão "Aplicar conduta recomendada" para dengue',
          id: 'suporte-decisao-clinica-botao-para-aplicar-conduta-recomendada-para-dengue-5-4',
        },

        ...getTopicIfEnabled(
          {
            title: 'Prescrição digital de medicamentos controlados',
            id: 'prescricao-digital-controlada-5-4',
          },
          PILOTO_PRESCRICAO_CONTROLADA_ENABLED
        ),

        ...getTopicIfEnabled(
          {
            title: 'Autorização para retirada de absorventes',
            id: 'programa-dignidade-menstrual-5-4',
          },
          PROGRAMA_DIGNIDADE_MENSTRUAL_ENABLED
        ),
      ],
    },
    '5-3-estabilizacao': {
      title: 'Estabilização 5.3',
      internalTitle: 'Versões de estabilização 5.3',
      Panel: NewsInternalEstabilizacaoV53,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.3.33',
          id: 'estabilizacao-5-3-33',
        },
        {
          title: '5.3.32',
          id: 'estabilizacao-5-3-32',
        },
        {
          title: '5.3.31',
          id: 'estabilizacao-5-3-31',
        },
        {
          title: '5.3.30',
          id: 'estabilizacao-5-3-30',
        },
        {
          title: '5.3.29',
          id: 'estabilizacao-5-3-29',
        },
        {
          title: '5.3.28',
          id: 'estabilizacao-5-3-28',
        },
        {
          title: '5.3.27',
          id: 'estabilizacao-5-3-27',
        },
        {
          title: '5.3.26',
          id: 'estabilizacao-5-3-26',
        },
        {
          title: '5.3.25',
          id: 'estabilizacao-5-3-25',
        },
        {
          title: '5.3.24',
          id: 'estabilizacao-5-3-24',
        },
        {
          title: '5.3.23',
          id: 'estabilizacao-5-3-23',
        },
        {
          title: '5.3.22',
          id: 'estabilizacao-5-3-22',
        },
        {
          title: '5.3.21',
          id: 'estabilizacao-5-3-21',
        },
        {
          title: '5.3.20',
          id: 'estabilizacao-5-3-20',
        },
        {
          title: '5.3.19',
          id: 'estabilizacao-5-3-19',
        },
      ],
    },
    '5-3': {
      title: 'Versão 5.3',
      Panel: NewsInternalPanelCincoTres,
      isEstabilizacao: false,
      topics: [
        { title: 'Resultado estruturado da prova do laço', id: 'resultado-estruturado-prova-do-laco-5-3' },
        { title: 'Solicitação de exames/procedimentos', id: 'solicitacao-exames-procedimentos-5-3' },
        { title: 'Acompanhamento de condições de saúde', id: 'acompanhamento-de-condicoes-de-saude-5-3' },

        {
          title: 'Agendamento entre profissionais',
          id: 'agendamento-entre-profissionais-5-3',
        },
        {
          title: 'Atestado Digital',
          id: 'atestado-digital-5-3',
        },

        { title: 'Busca ativa de vacinação', id: 'busca-ativa-vacinacao-5-3' },

        ...getTopicIfEnabled(
          {
            title: 'Cadastro de Imóveis e Famílias',
            id: 'cadastro-imoveis-familias-5-3',
          },
          CADASTRO_IMOVEL_ENABLED
        ),

        {
          title: 'Cuidado Compartilhado',
          id: 'cuidado-compartilhado-5-3',
        },
        {
          title: 'Fixar profissionais na agenda',
          id: 'fixar-profissionais-agenda-5-3',
        },
        {
          title: 'Prescrição de medicamentos',
          id: 'prescricao-medicamentos-5-3',
        },
        {
          title: 'Unificação de base',
          id: 'unificacao-base-5-3',
        },
        {
          title: 'Videochamada do profissional convidado adaptada para telefone celular',
          id: 'videochamada-mobile-5-3',
        },
        {
          title: 'Videochamada do profissional convidado adaptada para tablet',
          id: 'videochamada-tablet-5-3',
        },

        ...getTopicIfEnabled(
          {
            title: 'Saúde indígena',
            id: 'saude-indigena-5-3',
          },
          SAUDE_INDIGENA_ENABLED
        ),

        {
          title: 'Importação do bolsa família',
          id: 'bolsa-familia-5-3',
        },
        {
          title: 'Nome social do profissional',
          id: 'nome-social-profissional-5-3',
        },

        {
          title: 'Índice de Vulnerabilidade Clínico-Funcional',
          id: 'indice-de-vulnerabilidade-clinico-funcional-5-3',
        },

        {
          title: 'Índice de vulnerabilidade clínico funcional no Acompanhamento de condições de saúde',
          id: 'ivcf-no-acompanhamento-de-saude-5-3',
        },

        {
          title: 'API para transmissão de registros',
          id: 'api-transmissao-de-registros-5-3',
        },

        ...getTopicIfEnabled(
          {
            title: 'Serviços de referência',
            id: 'servicos-de-referencia-5-3',
          },
          PILOTO_VINCULACAO_CUIDADO_ENABLED
        ),

        {
          title: 'Histórico de acessos ao sistema',
          id: 'historico-acessos-5-3',
        },

        {
          title: 'Relatório de erros retornados pela RNDS',
          id: 'relatorio-erros-rnds-5-3',
        },
      ],
    },
    '5-2-estabilizacao': {
      title: 'Estabilização 5.2',
      internalTitle: 'Versões de estabilização 5.2',
      Panel: NewsInternalEstabilizacaoV52,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.2.48',
          id: 'estabilizacao-5-2-48',
        },
        {
          title: '5.2.47',
          id: 'estabilizacao-5-2-47',
        },
        {
          title: '5.2.46',
          id: 'estabilizacao-5-2-46',
        },
        {
          title: '5.2.45',
          id: 'estabilizacao-5-2-45',
        },
        {
          title: '5.2.44',
          id: 'estabilizacao-5-2-44',
        },
        {
          title: '5.2.43',
          id: 'estabilizacao-5-2-43',
        },
        {
          title: '5.2.42',
          id: 'estabilizacao-5-2-42',
        },
        {
          title: '5.2.41',
          id: 'estabilizacao-5-2-41',
        },
        {
          title: '5.2.40',
          id: 'estabilizacao-5-2-40',
        },
        {
          title: '5.2.39',
          id: 'estabilizacao-5-2-39',
        },
        {
          title: '5.2.38',
          id: 'estabilizacao-5-2-38',
        },
        {
          title: '5.2.37',
          id: 'estabilizacao-5-2-37',
        },
        {
          title: '5.2.36',
          id: 'estabilizacao-5-2-36',
        },
        {
          title: '5.2.35',
          id: 'estabilizacao-5-2-35',
        },
        {
          title: '5.2.33',
          id: 'estabilizacao-5-2-33',
        },
        {
          title: '5.2.32',
          id: 'estabilizacao-5-2-32',
        },
        {
          title: '5.2.31',
          id: 'estabilizacao-5-2-31',
        },
        {
          title: '5.2.30',
          id: 'estabilizacao-5-2-30',
        },
        {
          title: '5.2.29',
          id: 'estabilizacao-5-2-29',
        },
        {
          title: '5.2.28',
          id: 'estabilizacao-5-2-28',
        },
        {
          title: '5.2.27',
          id: 'estabilizacao-5-2-27',
        },
        {
          title: '5.2.26',
          id: 'estabilizacao-5-2-26',
        },
        {
          title: '5.2.24',
          id: 'estabilizacao-5-2-24',
        },
        {
          title: '5.2.23',
          id: 'estabilizacao-5-2-23',
        },
        {
          title: '5.2.22',
          id: 'estabilizacao-5-2-22',
        },
        {
          title: '5.2.21',
          id: 'estabilizacao-5-2-21',
        },
        {
          title: '5.2.20',
          id: 'estabilizacao-5-2-20',
        },
      ],
    },
    '5-2': {
      title: 'Versão 5.2',
      Panel: NewsInternalPanelCincoDois,
      isEstabilizacao: false,
      topics: [
        { title: 'Atualização da competência do SIGTAP', id: 'atualizacao-competencia-sigtap-5-2' },
        {
          title: 'Acompanhamento do Território',
          id: 'acompanhamento-territorio-5-2',
        },
        { title: 'Busca ativa de vacinação', id: 'busca-ativa-vacinacao-5-2' },
        ...[
          {
            title: 'Cuidado Compartilhado',
            id: 'cuidado-compartilhado-5-2',
          },
        ],
        ...[
          {
            title: 'e-SUS APS Ampliado',
            id: 'esusAmpliado-5-2',
          },
        ],
        { title: 'Facilidades no agendamento de consultas de pré-natal', id: 'agendamento-pre-natal-5-2' },
        { title: 'Gerenciamento de cookies', id: 'gerenciamento-de-cookies-5-2' },
        { title: 'Garantia do acesso', id: 'garantia-acesso-5-2' },
        ...[
          {
            title: 'Histórico do Cuidado Compartilhado',
            id: 'historico-cuidado-compartilhado-5-2',
          },
        ],
        {
          title: 'Modelos personalizados para relatórios gerenciais',
          id: 'modelos-personalizados-relatorios-gerenciais-5-2',
        },
        { title: 'Prescrição de medicamentos', id: 'prescricao-medicamentos-5-2' },
        { title: 'Prescrição digital', id: 'prescricao-digital-5-2' },
        {
          title: 'Relatório gerencial de cuidado compartilhado',
          id: 'relatorio-gerencial-cuidado-compartilhado-5-2',
        },
        { title: 'RNDS - Envio de registros', id: 'envio-rnds-5-2' },
        { title: 'Unificação de cadastros', id: 'unificacao-de-cadastros-5-2' },
        { title: 'Videochamadas', id: 'videochamadas-5-2' },
        { title: 'Vínculo entre equipes do PEC', id: 'equipes-vinculadas-5-2' },
      ],
    },
    '5-1-estabilizacao': {
      title: 'Estabilização 5.1',
      internalTitle: 'Versões de estabilização 5.1',
      Panel: NewsInternalEstabilizacaoV51,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.1.26',
          id: 'estabilizacao-5-1-26',
        },
        {
          title: '5.1.25',
          id: 'estabilizacao-5-1-25',
        },
        {
          title: '5.1.24',
          id: 'estabilizacao-5-1-24',
        },
        {
          title: '5.1.21',
          id: 'estabilizacao-5-1-21',
        },
        {
          title: '5.1.20',
          id: 'estabilizacao-5-1-20',
        },
        {
          title: '5.1.19',
          id: 'estabilizacao-5-1-19',
        },
        {
          title: '5.1.18',
          id: 'estabilizacao-5-1-18',
        },
        {
          title: '5.1.17',
          id: 'estabilizacao-5-1-17',
        },
      ],
    },
    '5-1': {
      title: 'Versão 5.1',
      Panel: NewsInternalPanelCincoUm,
      isEstabilizacao: false,
      topics: [
        { title: 'Marcadores de consumo alimentar', id: 'mca-5-1' },
        { title: 'Busca ativa de vacinação', id: 'busca-ativa-vacinacao-5-1' },
        {
          title: 'Encaminhamento externo',
          id: 'encaminhamento-5-1',
        },
        { title: 'Adaptação do PEC para uso do estagiário', id: 'estagiario-5-1' },
        { title: 'Reterritorialização', id: 'reterritorializacao-5-1' },
        { title: 'Observação do cidadão', id: 'observacao-5-1' },
        { title: 'Registro tardio', id: 'registro-tardio-5-1' },
        { title: 'Acompanhamento de cidadãos vinculados', id: 'acompanhamento-cidadaos-vinculados-5-1' },
        { title: 'CADSUS - Nova Sincronização', id: 'cadsus-sinc-5-1' },
      ],
    },
    '5-0-estabilizacao': {
      title: 'Estabilização 5.0',
      internalTitle: 'Versões de estabilização 5.0',
      Panel: NewsInternalEstabilizacaoV50,
      isEstabilizacao: true,
      topics: [
        {
          title: '5.0.24',
          id: 'estabilizacao-5-0-24',
        },
        {
          title: '5.0.23',
          id: 'estabilizacao-5-0-23',
        },
        {
          title: '5.0.22',
          id: 'estabilizacao-5-0-22',
        },
        {
          title: '5.0.21',
          id: 'estabilizacao-5-0-21',
        },
        {
          title: '5.0.20',
          id: 'estabilizacao-5-0-20',
        },
        {
          title: '5.0.19',
          id: 'estabilizacao-5-0-19',
        },
        {
          title: '5.0.18',
          id: 'estabilizacao-5-0-18',
        },
        {
          title: '5.0.17',
          id: 'estabilizacao-5-0-17',
        },
        {
          title: '5.0.16',
          id: 'estabilizacao-5-0-16',
        },
        {
          title: '5.0.15',
          id: 'estabilizacao-5-0-15',
        },
        {
          title: '5.0.14',
          id: 'estabilizacao-5-0-14',
        },
        {
          title: '5.0.13',
          id: 'estabilizacao-5-0-13',
        },
        {
          title: '5.0.12',
          id: 'estabilizacao-5-0-12',
        },
        {
          title: '5.0.11',
          id: 'estabilizacao-5-0-11',
        },
        {
          title: '5.0.10',
          id: 'estabilizacao-5-0-10',
        },
        {
          title: '5.0.9',
          id: 'estabilizacao-5-0-9',
        },
        {
          title: '5.0.8',
          id: 'estabilizacao-5-0-8',
        },
      ],
    },
    '5-0': {
      title: 'Versão 5.0',
      Panel: NewsInternalPanelCincoZero,
      isEstabilizacao: false,
      topics: [
        {
          title: 'Acompanhamentos',
          id: 'acompanhamentos-5-0',
        },
        {
          title: 'Alergias',
          id: 'alergias-5-0',
        },
        {
          title: 'Antecedentes',
          id: 'antecedentes-5-0',
        },
        {
          title: 'Atendimentos',
          id: 'atendimentos-5-0',
        },
        {
          title: 'Atendimento odontológico',
          id: 'atendimento-odonto-5-0',
        },
        {
          title: 'Atestados',
          id: 'atestados-5-0',
        },
        {
          title: 'Encaminhamentos e orientações',
          id: 'encaminhamento-orientacoes-5-0',
        },
        {
          title: 'Escuta inicial / pré-atendimento',
          id: 'escuta-inicial-5-0',
        },
        {
          title: 'Exames',
          id: 'exames-5-0',
        },
        {
          title: 'Histórico clínico do cidadão',
          id: 'historico-5-0',
        },
        {
          title: 'Medicamentos',
          id: 'medicamentos-5-0',
        },
        {
          title: 'Pré-natal / puerpério',
          id: 'pre-natal-5-0',
        },
        {
          title: 'Prontuário / folha de rosto',
          id: 'prontuario-5-0',
        },
        {
          title: 'Vacinação',
          id: 'vacinacao-5-0',
        },
      ],
    },
  }

  return NEWS_ITEMS
}
